import React from 'react';
import './TaxiInfo.css';

const TaxiInfo = ({ driver, tripDetails, status }) => {
  // Sort trip details by location type (pickup first, dropoff second)
  const sortedTripDetails = [...tripDetails].sort((a, b) => {
    if (a.locationType === 'pickup') return -1;
    if (b.locationType === 'pickup') return 1;
    return 0;
  });

  // Format date function
  const formatDateTime = (dateString) => {
    if (!dateString) return 'Not available';
    
    const date = new Date(dateString);
    return `${date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}(GMT+3)`;
  };

  return (
    <div className="taxi-info">
      <div className="trip-details">
        <h3>TRIP DETAILS</h3>
        {sortedTripDetails.map((location, index) => (
          <div className="location-item" key={index}>
            <div className={`location-marker ${location.locationType}-marker`}></div>
            <div className="location-info">
              <h4 className="location-title">{location.locationType === 'pickup' ? 'PICKUP' : 'DROPOFF'}</h4>
              <p className="location-address">{location.address}</p>
              <div className="location-time">
                {formatDateTime(location.arrived_at)}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="section-divider"></div>

      <div className="captain-info">
        <h3>CAPTAIN INFORMATION</h3>
        
        {/* Captain Avatar and Name */}
        <div className="info-row">
          <div className="avatar-container">
            {driver.avatar ? (
              <img 
                src={driver.avatar} 
                alt={driver.name} 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/70x70?text=Driver';
                }}
              />
            ) : (
              <img src="https://via.placeholder.com/70x70?text=Driver" alt="Driver" />
            )}
          </div>
          <div className="info-content">
            <p className="info-label">CAPTAIN</p>
            <p className="info-value">{driver.name}</p>
          </div>
        </div>

        {/* Phone Number with Call Button */}
        <div className="info-row">
          <div className="info-icon">
            <i className="fas fa-phone"></i>
          </div>
          <div className="info-content">
            <p className="info-label">PHONE</p>
            <p className="info-value">{driver.phone}</p>
            <a href={`tel:${driver.phone}`} className="call-button">
              <i className="fas fa-phone"></i> Call Driver
            </a>
          </div>
        </div>

        {/* Vehicle Information */}
        <div className="info-row">
          <div className="info-icon">
            <i className="fas fa-car"></i>
          </div>
          <div className="info-content">
            <p className="info-label">{driver.vehicle_model}</p>
            <p className="info-value">{driver.vehicle_model_details}</p>
            <div className="plate-number">{driver.vehicle_plate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxiInfo;
